import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {
  NextProject,
  ProjectAwards,
  ProjectBannerImage,
  ProjectDescription,
  ProjectDownloads,
  ProjectImpacts,
  ProjectLinks,
  ProjectListTextImage,
  ProjectVideos,
} from '../atoms';
import BannerSlider from '../modules/BannerSlider/BannerSlider';

// Search this string (projectKeel) in translations
const pathProject = "projectKeel";

const ProjectKeel = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lng = localStorage.getItem("language");
    i18n.changeLanguage(lng);
  }, [i18n])

  return (
    <div className='projectLayout'>
      <Helmet>
        <title>Keel | Instituto E</title>
      </Helmet>
      <BannerSlider
        slides={
          [
            {
              image: "../../../images/projects/keel/1.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/keel/2.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/keel/3.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/keel/4.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/keel/5.jpg",
              alt: "description alt image",
            }
          ]}>
      </BannerSlider>

      {/* Possible to import all inside div with class: "projectLayoutContent", in the following order:
          - ProjectDescription
          - ProjectImpacts
          - ProjectAwards
          - ProjectLinks
          - ProjectVideos
          - ProjectDownloads
          - Outside the div: ProjectBannerImage
          - Outside the div: ProjectListTextImage */}

      <div className='projectLayoutContent'>
        <ProjectDescription
          title={`${t(`${pathProject}.title`)}`}
          subtitle={`${t(`${pathProject}.subtitle`)}`}
          paragraphs={[
            {
              type: "text",
              p: `${t(`${pathProject}.p1`)}`
            },
            {
              type: "text",
              p: `${t(`${pathProject}.p2`)}`
            }
          ]} />

        <p className='projectLayout__asterisco'>{t(`${pathProject}.asterisco`)}</p>

        <ProjectVideos
          videos={[
            {
              linkYT: 'https://www.youtube.com/watch?v=tuZkj1US5-A&t=343s&ab_channel=Instituto-e',
              textVideo: `${t(`${pathProject}.videoText1`)}`
            }
          ]} />
      </div>

      <NextProject link="project-sustainability"></NextProject>

    </div>
  )
};

export default ProjectKeel;
